import Text from '../../../../Text'
import { formatPrice } from '../../../../../utils/formats'
import SecondaryNavbar from '../../SecondaryNavbar' // direct import, not the sections barrel (#130 de-barrel)
import React from 'react'
import styles from './styles.module.css'

const cx = (...c) => c.filter(Boolean).join(' ')

function SecondaryNavbarAddToCart({ title, subtotal, subtotalBeforeDiscount, ctaV2 }) {
  const renderPriceNavItem = (price, priceBeforeDiscount) => {
    return (
      <>
        <div className={styles.prices}>
          { !!priceBeforeDiscount
            && !!price
            && priceBeforeDiscount.priceCents !== price.priceCents &&
            <div className={cx(styles.price, styles.priceBeforeDiscount)}><Text type={'regular'}>{formatPrice(priceBeforeDiscount)}</Text></div>
          }
          <div className={styles.price}><Text type={'heading-6'}>{formatPrice(price)}</Text></div>
        </div>
      </>
    )
  }

  const navItemsComponents = []
  subtotal && navItemsComponents.push(renderPriceNavItem(subtotal, subtotalBeforeDiscount))

  return (
    <SecondaryNavbar
      title={title}
      sx={{ titleTextType: 'heading-7', hideTitleOnMobile: true, largeContainer: true }}
      navItemsComponents={navItemsComponents}
      ctaV2={ctaV2}
    />
  )
}

export default SecondaryNavbarAddToCart
